module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1vYkW"))).then(() => parcelRequire('f4eak'));